import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=1e15231c&scoped=true"
import script from "./PromotionList.vue?vue&type=script&lang=js"
export * from "./PromotionList.vue?vue&type=script&lang=js"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=1e15231c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e15231c",
  null
  
)

export default component.exports